import { CircleUserRound } from "lucide-react";
import { Img } from "./Img";

interface UserAvatarProps {
  src: string | null | undefined;
  blurhash?: string | null;
  size: number;
  alt: string;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Renders a user avatar with the image CDN transform pipeline. Falls back to
 * a generic person icon (per CLAUDE.md — never initials) when no URL is set.
 */
export function UserAvatar({ src, blurhash, size, alt, className, style }: UserAvatarProps) {
  const baseStyle: React.CSSProperties = {
    width: size,
    height: size,
    borderRadius: "50%",
    objectFit: "cover",
    ...style,
  };

  if (src) {
    return (
      <Img
        src={src}
        alt={alt}
        variant="avatar"
        renderedWidth={size}
        blurhash={blurhash}
        width={size}
        height={size}
        className={className}
        style={baseStyle}
      />
    );
  }

  return (
    <div
      className={className}
      style={{
        ...baseStyle,
        backgroundColor: "#E5E7EB",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      aria-label={alt}
    >
      <CircleUserRound size={size * 0.7} color="#9CA3AF" />
    </div>
  );
}
